module.exports = __webpack_public_path__ + "img/photoCasually.b3d5ad90.png";